import React, { useState, useEffect } from 'react';
import '../styles/Pages.css';

export default function Receitas() {
  const [receitas, setReceitas] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    descricao: '',
    valor: '',
    categoria: 'salário',
    tipo: 'unica',
    data: new Date().toISOString().split('T')[0]
  });

  useEffect(() => { carregarReceitas(); }, []);

  const carregarReceitas = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/receitas', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setReceitas(data.receitas || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const handleAddOuEditar = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const url = editingId ? `/api/receitas/${editingId}` : '/api/receitas';
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ ...formData, valor: parseFloat(formData.valor) })
      });
      const data = await res.json();
      if (data.success) {
        handleCancelar();
        carregarReceitas();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleEditar = (receita) => {
    setFormData({
      descricao: receita.descricao,
      valor: receita.valor,
      categoria: receita.categoria,
      tipo: receita.tipo || 'unica',
      data: receita.data.split('T')[0]
    });
    setEditingId(receita.id);
    setShowForm(true);
  };

  const handleDeletar = async (id) => {
    if (!window.confirm('Deletar?')) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/receitas/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) carregarReceitas();
    } catch (error) { console.error('Erro:', error); }
  };

  const handleCancelar = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({ descricao: '', valor: '', categoria: 'salário', tipo: 'unica', data: new Date().toISOString().split('T')[0] });
  };

  return (
    <div className="page">
      <h1>📈 Receitas</h1>
      <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
        {showForm ? '✕ Cancelar' : '+ Adicionar Receita'}
      </button>

      {showForm && (
        <form onSubmit={handleAddOuEditar} className="form-card">
          <div className="form-group">
            <label>Descrição</label>
            <input type="text" value={formData.descricao} onChange={(e) => setFormData({...formData, descricao: e.target.value})} placeholder="Ex: Salário" required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Valor (R$)</label>
              <input type="number" value={formData.valor} onChange={(e) => setFormData({...formData, valor: e.target.value})} step="0.01" required />
            </div>
            <div className="form-group">
              <label>Data</label>
              <input type="date" value={formData.data} onChange={(e) => setFormData({...formData, data: e.target.value})} required />
            </div>
          </div>
          <div className="form-group">
            <label>Tipo</label>
            <select value={formData.tipo} onChange={(e) => setFormData({...formData, tipo: e.target.value})}>
              <option value="unica">Única</option>
              <option value="recorrente">Recorrente (mensal)</option>
            </select>
          </div>
          <div className="form-buttons">
            <button type="submit" className="btn-primary">{editingId ? 'Atualizar' : 'Adicionar'}</button>
            <button type="button" className="btn-secondary" onClick={handleCancelar}>Cancelar</button>
          </div>
        </form>
      )}

      <div className="table-container">
        <table>
          <thead><tr><th>Descrição</th><th>Valor</th><th>Data</th><th>Tipo</th><th>Ações</th></tr></thead>
          <tbody>
            {receitas.map(r => (
              <tr key={r.id}>
                <td>{r.descricao}</td>
                <td>R$ {parseFloat(r.valor).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</td>
                <td>{new Date(r.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</td>
                <td><span className="type-badge">{r.tipo === 'recorrente' ? 'Recorrente' : 'Única'}</span></td>
                <td>
                  <button type="button" className="btn-small" onClick={() => handleEditar(r)}>✏️ Editar</button>
                  <button type="button" className="btn-small danger" onClick={() => handleDeletar(r.id)}>🗑️ Deletar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
